import { INavData } from '@coreui/angular';

/** Menù statico, da utilizzare come esempio (le singole voci di menù che alimentano il componente app-sidebar-nav devono implementare l'interfaccia INavData, l'oggetto da passare al componente deve essere un Array<INavData> */
export const navItems: Array<INavData> = [
  {
    name: 'Anagrafiche',
    url: '/anagrafiche',
    icon: 'fas fa-address-book',
    children: [
      {
        name: 'Map',
        url: '/anagrafiche/societa',
        icon: 'fas fa-square'
      },
      
    ]
  },
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'fas fa-tachometer-alt',
    badge: {
      text: 'NEW',
      color: 'primary'
    }
  },
  //{
  //  title: true,
  //  name: 'Components'
  //},
  {
    name: 'RsMap',
    url: '/rsmap',
    icon: 'fas fa-route',
    children: [
      {
        name: 'Map',
        url: '/rsmap/map',
        icon: 'fas fa-square'
      },
      {
        name: 'Map dual',
        url: '/rsmap/map-dual-panels',
        icon: 'fas fa-clone'
      },
      {
        name: 'Profile zone',
        url: '/rsmap/profile-zone',
        icon: undefined
      },
      {
        name: 'Gestione coordinate',
        url: '/rsmap/coordinates-manage',
        icon: undefined
      },
    ]
  },
  {
    name: 'Profile',
    url: '/profile',
    icon: 'fas fa-user',
    children: [
      {
        name: 'Profile group manager',
        url: '/profile/manage/group',
        icon: undefined
      },
      {
        name: 'Profile user manager',
        url: '/profile/manage/user',
        icon: undefined
      },
    ]
  },
  {
    name: 'App menu',
    url: '/appmenu',
    icon: 'fas fa-bars',
    children: [
      {
        name: 'Edit',
        url: '/appmenu/edit',
        icon: undefined
      },
      {
        name: 'Permission',
        url: '/appmenu/permission',
        icon: undefined
      },
    ]
  },
  {
    name: 'Session manager',
    url: '/session-manager',
    icon: 'fas fa-wifi',
    children: [
      {
        name: 'Connected users',
        url: '/session-manager/connected-users',
        icon: undefined
      }
    ]
  },
  /**
   * // Commentato perché inutile, ma lasciato a titolo di esempio
  {
    divider: true
  },
  {
    title: true,
    name: 'Extras',
  },
  {
    name: 'Download CoreUI',
    url: 'http://coreui.io/angular/',
    icon: 'icon-cloud-download',
    class: 'mt-auto',
    variant: 'success'
  },
  */
];
